import { TypeIdSchema } from '@unipile/db';
import { Type, type Static } from '@sinclair/typebox';
import { ProviderSchema } from '../../common/provider.schema';
import { PublicWebhookConversationSchema } from './webhook-conversation.schema';

export const ListWebhookConversationsResponseSchema = Type.Object({
  object: Type.Literal('WebhookConversations'),
  data: Type.Array(PublicWebhookConversationSchema),
  has_more: Type.Boolean(),
});
export type ListWebhookConversationsResponse = Static<typeof ListWebhookConversationsResponseSchema>;

export const WebhookConversationAccountSchema = Type.Object(
  {
    object: Type.Literal('WebhookConversationAccount', { description: 'The type of the returned object.' }),
    id: TypeIdSchema('account', { description: 'ID of the account that emitted the delivered events.' }),
    name: Type.Union([Type.String(), Type.Null()], {
      description: 'The name of the account, or `null` if the account has no name or has been deleted.',
    }),
    provider: Type.Union([ProviderSchema, Type.Null()], {
      description: 'The provider of the account, or `null` if the account has been deleted.',
    }),
  },
  { description: 'An account whose events were delivered to a webhook endpoint.' },
);
export type WebhookConversationAccount = Static<typeof WebhookConversationAccountSchema>;

export const ListWebhookConversationAccountsResponseSchema = Type.Object(
  {
    object: Type.Literal('WebhookConversationAccounts', { description: 'The type of the returned object.' }),
    data: Type.Array(WebhookConversationAccountSchema, { description: 'The accounts, ordered by name.' }),
  },
  { description: 'The accounts whose events were delivered to a webhook endpoint.' },
);
export type ListWebhookConversationAccountsResponse = Static<typeof ListWebhookConversationAccountsResponseSchema>;
